import { render, staticRenderFns } from "./ClientUpdateScreen.vue?vue&type=template&id=27909684&scoped=true&"
import script from "./ClientUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./ClientUpdateScreen.vue?vue&type=script&lang=js&"
import style0 from "./ClientUpdateScreen.vue?vue&type=style&index=0&id=27909684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27909684",
  null
  
)

export default component.exports